import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { TemplateDesignElement } from '../../design-element';
import {
  CommunicationTemplate,
  CommunicationTemplateViewControl,
  ConfirmationType,
  MassNotificationTemplate,
  MessageSettings
} from 'src/app/modules/communications/store/communications';
import { TemplateDesignerService } from 'src/app/modules/communications/services/template-designer.service';
import { TextElementSettings } from '../text-control/text-control-model';
import produce from 'immer';

@Component({
    selector: 'app-sms-text-control',
    templateUrl: './sms-text-control.component.html',
    styleUrls: ['./sms-text-control.component.scss'],
    standalone: false
})
export class SmsTextControlComponent implements OnInit, OnDestroy, TemplateDesignElement {
  @Input() index: number;
  @Input() messageSettings?: MessageSettings;
  @Input() template?: CommunicationTemplate;
  @Input() control?: CommunicationTemplateViewControl;
  @Input() set culture(value: string) {
    this._culture = value;
    if (!this.editMode && !!value) {
      this.render();
    }
  }
  _culture: string;
  @Input() orgLanguages: string[];
  @Input() selected: boolean;
  @Output() settingsChanged = new EventEmitter<{ uId: string; settings: any }>();
  @Output() controlBusy = new EventEmitter();
  @Output() controlReady = new EventEmitter();

  editMode: boolean;
  showText: boolean = false;
  textValue: string;
  textOrPlaceHolder: string;
  runtimeMode: boolean;

  constructor(private templateDesignerService: TemplateDesignerService) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  private getEditPlaceHolder(): string {
    if (!!this.templateDesignerService.staticTextTranslations?.['EDIT-TEXT-PLACEHOLDER'][this._culture]) {
      var defaultText = this.templateDesignerService.staticTextTranslations['EDIT-TEXT-PLACEHOLDER'][this._culture];
      return `<div style="font-size: 14px; font-family: Verdana, Geneva, Tahoma, sans-serif; font-weight: 400; color: #000000">${defaultText}</div>`;
    }

    return null;
  }

  onEditClick(): void {
    this.showText = true;
    this.controlBusy.emit();
  }

  onTextChanged(): void {
    const control = produce(this.control, draftState => {
      if (!!!draftState.settings) {
        draftState.settings = {
          richText: {}
        } as TextElementSettings;
      }
      if (!draftState.settings.richText) {
        draftState.settings.richText = {};
      }
      draftState.settings.richText[this._culture] = this.textValue;
    });

    this.textOrPlaceHolder = this.textValue;
    this.settingsChanged.emit({ uId: this.control.uId, settings: control.settings });
  }

  loadSettings(): void {
    this.showText = false;
    this.editMode = true;
    this.loadData();
  }

  private loadData(): void {
    const settings: TextElementSettings = this.control?.settings;

    let textValue = this.templateDesignerService.getTranslateText(settings?.richText, this._culture);
    if (this.runtimeMode !== true) {
      if (!!textValue) {
        this.textValue = textValue;
        this.textOrPlaceHolder = this.textValue;
      } else {
        this.textOrPlaceHolder = this.getEditPlaceHolder();
      }

      return;
    }
  }

  saveSettings(): boolean {
    return true;
  }

  render(): void {
    this.editMode = false;
    this.loadData();
  }

  edit(): void {
    this.onEditClick();
  }

  updateText(text: string): void {
    this.showText = false;
    const control = produce(this.control, draftState => {
      if (!!!draftState.settings) {
        draftState.settings = {
          richText: {}
        } as TextElementSettings;
      }
      if (!draftState.settings.richText) {
        draftState.settings.richText = {};
      }
      draftState.settings.richText[this._culture] = text;
    });

    this.control = control;

    this.textValue = text;
    this.textOrPlaceHolder = this.textValue;
    this.settingsChanged.emit({ uId: this.control.uId, settings: control.settings });
  }

  cancelText(): void {
    this.showText = false;
    this.controlReady.emit();
  }

  setRuntimeData(value: any) {
    this.runtimeMode = true;
    if (!this.editMode && !!value) {
      const settings = value as TextElementSettings;
      let textValue = this.templateDesignerService.getTranslateText(settings?.richText, this._culture);
      if (!!textValue) {
        this.textValue = textValue;
        this.textOrPlaceHolder = this.textValue;
      } else {
        this.textOrPlaceHolder = this.getEditPlaceHolder();
      }

      const control = produce(this.control, draftState => {
        if (!!!draftState.settings) {
          draftState.settings = {
            richText: {}
          } as TextElementSettings;
        }
        draftState.settings.richText[this._culture] = this.textValue;
      });
    }
  }
}
